module.exports = __webpack_public_path__ + "img/plateau_nenuphar.55a85486.webp";